import React, { ReactNode } from 'react'
import { Backdrop, Box, Button, Checkbox, Container, Dialog, DialogActions, DialogTitle, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import CMSApi from '../../utils/opsloth_cms_service_api'
import imgTool from '../../utils/imgTool'
import ExcelJS from 'exceljs'
import savefile from '../../utils/savefile';
import CircularProgressWithLabel from '../public/CircularProgressWithLabel';
import select_items from '../../utils/select_items'
import exportOrdersToExcel from '../../utils/exportOrdersToExcel'
import calcStockAndPrice from '../../utils/calcStockAndPrice'

function OrderTableArray(props: any) {
  const [showMore, setShowMore] = React.useState(false)
  const [products, setProducts] = React.useState(props.order?.products?.slice(0, 1))

  const [chooseDialogShow, setChooseDialogShow] = React.useState(false)
  const [chooseDialogItems, setChooseDialogItems] = React.useState<string[]>([])
  const [chooseItemClickedValue, setChooseItemClickedValue] = React.useState('/')

  const [realColumnsModifyDialogShow, setRealColumnsModifyDialogShow] = React.useState(false)
  const [realColumnsClickedValue, setRealColumnsClickedValue] = React.useState(0)
  const [realColumnsInputValue, setRealColumnsInputValue] = React.useState(0)

  const modifyClickedIndex = React.useRef(-1)
  const [clickedDialogKey, setClickedDialogKey] = React.useState('')

  const lastCheckedSubProductIndex = React.useRef(0)
  const [checkedSubproductArray, setCheckedSubproductArray] = React.useState<number[]>([])
  const [exportPercentage, setExportPercentage] = React.useState(0)

  const minimal_base64_img = 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  const ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']


  let headers = ['序号', '例图', '品牌', '货号', '日文名称', '中文名称', '日元售价', '代理版(元/个)', '日版(元/个)', '每袋数量', '每箱数量', '订购(袋)', '订购(箱)', '备注', '发货数量', '金额', '发货状态']
  let headers_key = ['order', 'mainImage', 'brand', 'product_code', 'name_jp', 'name_zh', 'price_jpy', 'price_cny_cn', 'price_cny_jp', 'pack_spec', 'carton_spec', 'order_number_pack', 'order_number_carton', 'order_remark', 'real_number', 'order_price', 'cargo_sent']
  let order_headers = ['订单金额￥', '已付定金￥', '物流费用￥', '已付尾款￥', '物流状态', '物流单号', '订单状态', '订单备注', '创建者', '创建时间']
  let order_headers_key = ['price_cny', 'deposit_cny', 'logistic_cny', 'balance_cny', 'cargo_sent', 'cargo_no', 'order_status', 'remark', 'nickname', 'createdAt']


  const handleMoreClick = async () => {
    if (showMore) {
      setShowMore(false)
      setProducts(props?.order?.products?.slice(0, 1))
    } else {
      setShowMore(true)
      setProducts(props?.order?.products)
    }
  }

  const handleChooseItemClick = (event: any, key: string) => {
    if (key === 'cargo_sent') {
      setChooseDialogItems(['/', '已请款', '已发货', '已取消'])
    }

    if (key === 'real_status') {
      setChooseDialogItems(['/', '提交报关', '报关失败', '报关成功'])
    }

    if (key === 'can_pay_balance') {
      setChooseDialogItems(['不可补款', '可补款', '砍单', "已补款"])
    }
    setClickedDialogKey(key)

    setChooseDialogShow(true)
    setChooseItemClickedValue((event.target as any).textContent)
  }

  const handleChooseItemChange = async (event: any) => {
    let column_name = ''
    if (clickedDialogKey === 'cargo_sent') {
      column_name = '发货状态'
    }

    if (clickedDialogKey === 'real_status') {
      column_name = '报关进度'
    }

    if (clickedDialogKey === 'can_pay_balance') {
      column_name = '开启补款'
    }

    await modifySubProdct(clickedDialogKey, modifyClickedIndex.current, event.target.value, column_name, checkedSubproductArray)
  }

  const handleOrderChecked = (event: any) => {
    function modifyCheckedArrayByIndex(index: number) {
      // console.log(event.target.checked, checkedSubproductArray.indexOf(index))
      if (event.target.checked && checkedSubproductArray.indexOf(index) == -1) {
        props.order.products[index].excelOutchecked = true
        if (props.setOrderTableResFilteredFunction) {
          props.setOrderTableResFilteredFunction()
        }
        checkedSubproductArray.push(index)
      } else if (!event.target.checked && checkedSubproductArray.indexOf(index) >= 0) {
        delete props.order.products[index].excelOutchecked
        if (props.setOrderTableResFilteredFunction) {
          props.setOrderTableResFilteredFunction()
        }
        checkedSubproductArray.splice(checkedSubproductArray.indexOf(index), 1)
      }
      // console.log(checkedSubproductArray)
    }

    if (showMore) {
      if (event.shiftKey) {
        for (let i = Math.min(lastCheckedSubProductIndex.current, parseInt(event.target.dataset.index)); i < Math.min(lastCheckedSubProductIndex.current, parseInt(event.target.dataset.index)) + 1 + Math.abs(lastCheckedSubProductIndex.current - parseInt(event.target.dataset.index)); i++) {
          modifyCheckedArrayByIndex(i)
        }
      } else {
        modifyCheckedArrayByIndex(parseInt(event.target.dataset.index))
      }
      setCheckedSubproductArray([...checkedSubproductArray])
      lastCheckedSubProductIndex.current = parseInt(event.target.dataset.index)
    }
  }

  const handleModifyClick = (event: any, key: string) => {
    setRealColumnsClickedValue(event.target.textContent)
    setRealColumnsInputValue(event.target.textContent)
    setRealColumnsModifyDialogShow(true)
    setClickedDialogKey(key)

  }

  const handleRealColumnInput = (event: any) => {
    setRealColumnsInputValue(event.target.value)
  }

  const handleRealColumnModifySubmit = async (event: any) => {
    let column_name = headers[headers_key.indexOf(clickedDialogKey)]
    if (clickedDialogKey === 'real_number') {
      if (props.category == '海关') {
        column_name = '报关(个)'
      } else {
        column_name = '发货数量'
      }
    }
    if (clickedDialogKey === 'can_pay_balance_number') {
      column_name = "补款数量"
    }
    await modifySubProdct(clickedDialogKey, modifyClickedIndex.current, realColumnsInputValue, column_name, checkedSubproductArray)
    setRealColumnsModifyDialogShow(false)
  }

  const modifySubProdct = (key: string | number, subClickIndex: number, newValue: string | number, column_name: string, checkedArray: number[]) => {
    return new Promise(async (resolve) => {
      //TODO 区分stastics和订单列表能更新发货状态
      if (props.order._id) {//单个订单下的子商品更新
        const dataModel = new CMSApi('orders' + '/' + props.order._id)
        let updateData: any = { $set: {} }
        let checkedName = [products[subClickIndex].name_zh ?? '']
        if (checkedArray.length > 0) {
          for (let i = 0; i < checkedArray.length; i++) {
            updateData.$set[`products.${checkedArray[i]}.${key}`] = newValue
            checkedName[i] = products[checkedArray[i]].name_zh ?? ""
          }
        } else {
          updateData.$set[`products.${subClickIndex}.${key}`] = newValue
        }
        const updateRes: any = await dataModel.put(updateData)
        if (updateRes.data.modifiedCount == 1) {
          const logDataModel = new CMSApi('logs')
          logDataModel.post({
            table_name: 'Orders',
            document_id: props.order._id,
            column_key: 'products',
            column_name: checkedName.toString() + "\n" + column_name,
            old_value: products[subClickIndex][key] ?? '/',
            new_value: newValue,
            mainImage: '',
            log_user: (window as any).user_nickname ?? '无名称'
          })
          if (checkedArray.length > 0) {
            for (let i = 0; i < checkedArray.length; i++) {
              props.order.products[checkedArray[i]][key] = newValue
            }
          } else {
            props.order.products[subClickIndex][key] = newValue
          }
          resolve(true)
        }
      } else {//统计数据中上半部分，勾选多个，多个订单更新
        let order_subproduct_ids: any[] = []
        let checked_order_ids: any[] = []
        props.order.products?.forEach((product: any) => {
          if (product.excelOutchecked && product._id) {
            order_subproduct_ids.push(product._id)
            checked_order_ids.push(product.order_id)
          }
        })
        if (checked_order_ids.length <= 100) {
          if (order_subproduct_ids.length == 0) {//如果没有单独表格选中，仅仅是单个直接修改
            order_subproduct_ids.push(props.order.products[subClickIndex]._id)
            checked_order_ids.push(props.order.products[subClickIndex].order_id)
          }
          let updateData: any = { "$set": {} }
          updateData["$set"]["products.$[elem]." + key] = newValue
          if (newValue == "不可补款" || newValue == "砍单") {
            updateData["$unset"] = {}
            updateData["$unset"]["products.$[elem].can_pay_balance_number"] = ""
          }
          const dataModel = new CMSApi('orders')
          const updateRes: any = await dataModel.setFilter({ "_id": { "$in": checked_order_ids }, deleted: { "$ne": true } })
            .setOptions({ arrayFilters: [{ "elem._id": { "$in": order_subproduct_ids } }] })
            .put(updateData)
          if (updateRes.data.modifiedCount) {
            let products_logs_data: any[] = []
            props.order.products?.forEach((product: any, product_index: number) => {
              console.log()
              if (order_subproduct_ids.indexOf(product._id) >= 0) {
                products_logs_data.push({
                  table_name: 'Orders',
                  document_id: product.order_id,
                  column_key: 'products',
                  column_name: product.name_zh.toString() + "\n" + column_name,
                  old_value: product[key] ?? '/',
                  new_value: newValue,
                  mainImage: '',
                  log_user: (window as any).user_nickname ?? '无名称'
                })
                props.order.products[product_index][key] = newValue
                if (newValue == "不可补款" || newValue == "砍单") {
                  props.order.products[product_index]["can_pay_balance_number"] = ""
                }
              }
            })
            const logDataModel = new CMSApi('logs')
            setRealColumnsModifyDialogShow(false)
            setChooseDialogShow(false)
            logDataModel.post(products_logs_data)
          }
        } else {
          alert("超过100批量修改数量限制！")
        }
      }
    })
  }

  const handleExportClick = async () => {
    exportOrdersToExcel(
      headers,
      headers_key,
      products,
      checkedSubproductArray,
      props.schema.category.label,
      props.order.logistic_cny,
      props.order.company,
      props.order.domin,
      props.order.out_trade_no,
      setExportPercentage
    )
  }

  const getBase64Image = (imgUrl: string) => {
    return new Promise((resolve, reject) => {
      if (imgUrl && imgUrl != '/') {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = imgUrl
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx: any = canvas.getContext('2d');
          canvas.height = image.naturalHeight;
          canvas.width = image.naturalWidth;
          ctx.drawImage(image, 0, 0);
          const dataUrl = canvas.toDataURL();
          resolve(dataUrl)
        }
      } else {
        resolve(minimal_base64_img)
      }
    })
  }

  React.useEffect(() => {
    setShowMore(false)
    setProducts(props.order.products?.slice(0, 1))
  }, [props.order.products])

  React.useEffect(() => {
    if (!showMore) {
      props.order.products.forEach((product: { excelOutchecked: any }) => {
        delete product.excelOutchecked
      })
      if (props.setOrderTableResFilteredFunction) {
        props.setOrderTableResFilteredFunction()
      }
      setCheckedSubproductArray([])
    }
  }, [showMore])

  return (
    <TableContainer
      sx={{ overflowX: showMore ? 'scroll' : 'hidden' }}
    >
      <Table>
        {
          showMore &&
          <Box sx={{ display: 'flex', position: 'absolute' }}>
            <Box
              onClick={handleMoreClick}
              sx={{ ml: .5, px: '1em', py: '.2em', height: '1.5em', lineHeight: '1.5em', background: '#0d47a166', cursor: 'pointer', color: 'white', fontWeight: 'bold', fontSize: '1em', textAlign: 'center', position: 'relative' }}
            >收起</Box>
            <Box
              onClick={handleExportClick}
              sx={{ ml: '2em', height: '1.5em', px: '1em', py: '.2em', lineHeight: '1.5em', background: '#0d47a166', cursor: 'pointer', color: 'white', fontWeight: 'bold', fontSize: '1em', textAlign: 'center', position: 'relative' }}
            >导出订单{checkedSubproductArray.length > 0 ? ' 选中 ' + checkedSubproductArray.length + ' 个' : ''}</Box>
          </Box>
        }
        <TableHead>
          <TableRow>
            {
              props.headers?.map((value: string, value_index: number) => {
                return <TableCell
                  key={value_index}
                  sx={{
                    fontSize: '.4em',
                    minWidth: '1em',
                    maxWidth: '20em',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    borderLeft: 'solid 1px #ccc',
                    borderTop: 'solid 1px #ccc',
                    background: '#DCE6F1',
                  }}
                  size="small"
                >{value as ReactNode}</TableCell>
              })
            }
          </TableRow>
        </TableHead>
        <TableBody>

          {
            products?.map((row: any, row_index: number) => (
              <TableRow
                key={`row_${row_index}`}
                sx={{ background: props.checkboxSelected?.indexOf(row.product_id) >= 0 ? '#feff6b' : 'none' }}
              >
                {
                  props.headers_key.map((key: any, value_index: number) => {
                    let value = undefined
                    let price = undefined
                    if (key === 'order') {
                      value = row_index + 1
                    } else if (key === 'cargo_sent' || key === 'real_status' || key === 'custom_carton') {
                      value = row[key] === '/' || row[key] == undefined || !row[key] ? '/' : row[key]
                    } else if (key === 'real_number') {
                      if (!isNaN(row["warehouse_stock"])) {
                        value = calcStockAndPrice.calcStockAndPrice(
                          Math.max(row["price_cny_cn"] ?? 0, row["price_cny_jp"] ?? 0),
                          row["pack_spec"],
                          row["carton_spec"],
                          row["order_number_pack"],
                          row["order_number_carton"],
                          row["warehouse_stock"],
                          row["category"]
                        ).totalStock
                      } else {
                        value = row[key]
                      }
                    } else {
                      value = row[key]
                    }
                    return <TableCell
                      key={value_index}
                      data-index={row_index}
                      onClick={(event) => {
                        modifyClickedIndex.current = row_index
                        if ((key === 'cargo_sent' || key === 'real_status' || key === "can_pay_balance") && showMore) {
                          handleChooseItemClick(event, key)
                        }
                        if ((key === 'product_code' || key === 'real_pack' || key === 'real_carton' || key === 'real_number' || key === 'order_remark' || key === 'custom_carton' || key === "can_pay_balance_number") && showMore) {
                          handleModifyClick(event, key)
                        }
                      }}
                      sx={{
                        px: 1,
                        cursor: (key === 'product_code' || key === 'cargo_sent' || key === 'real_pack' || key === 'real_carton' || key === 'real_number' || key === 'real_status' || key === 'order_remark' || key === 'custom_carton' || key === "can_pay_balance" || key === "can_pay_balance_number") ? 'pointer' : 'inherit',
                        textAlign: 'center',
                        fontSize: '.4em',
                        minWidth: '1em',
                        maxWidth: '20em',
                        maxHeight: '3em',
                        overflow: 'hidden',
                        whiteSpace: 'pre-wrap',
                        borderLeft: 'solid 1px #ccc',
                        borderRight: 'solid 1px #ccc',
                        background: (value > 0 && (key === 'order_number_pack' || key === 'order_number_carton' || key === 'order_remark'))
                          ? (row['product_id'] ? '#DAEEF3' : '#f7a3ff')
                          : row['cargo_sent']?.indexOf('已取消') >=0  ? '#ffd2cb' : 'none'
                            && (checkedSubproductArray.indexOf(row_index) >= 0 ? '#0d47a120' : 'none')
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: key == 'double_checked' && row['double_checked']?.indexOf(select_items.double_checked[0].value) >= 0 ? '#f7a3ff' : 'none' }}>
                        {
                          key === 'mainImage'
                            ?
                            <img
                              src={imgTool.getSmallerImgUrl(value, 64)}
                              style={{ width: '6em', height: '8em', objectFit: 'cover', transformOrigin: 'left center' }}
                            />
                            :
                            (
                              key == "launch_date" || key == "cut_off_date"
                                ? new Date(value).toLocaleDateString()
                                : (row?.product_id ? value as ReactNode : (value_index == 0 || value_index == 2 || value_index == 4 || value_index == 5 ? "无产品id" : value as ReactNode))
                            )
                        }
                        {
                          value_index === 0 && <Checkbox inputProps={{ 'data-index': row_index } as any} sx={{ p: 0, cursor: 'pointer' }} onClick={handleOrderChecked} checked={checkedSubproductArray.indexOf(row_index) >= 0} color="primary" />
                        }
                      </Box>
                    </TableCell>
                  })
                }
                {(props.order?.order_type?.indexOf('预售') >= 0 && row?.can_pay_balance) && <Box sx={{ width: 0 }}>
                  <Typography variant='body2' sx={{ position: 'relative', left: '-17.5vw', float: 'left', lineHeight: 1, mt: 2, p: 1, border: '1px solid #1976d2', background: row?.can_pay_balance == '已补款' ? '' : 'gold' }}>{row?.can_pay_balance}</Typography>
                </Box>}
              </TableRow>

            ))
          }
          <TableRow>
            {/* {
              props.headers.map((value: string, value_index: number) =>
              <TableCell>{'last row'}</TableCell>
              )
              
            }
            {
              <TableCell>{'total price'}</TableCell>
            } */}
          </TableRow>

        </TableBody>
      </Table>
      {
        !showMore && <Box
          sx={{ width: '100%', mt: -9, cursor: 'pointer', clipPath: 'ellipse(60% 100% at 50% 115%)' }}
          onClick={handleMoreClick}
        >
          <Paper
            sx={{ p: 3, background: '#0d47a166', userSelect: 'none', color: 'white', fontWeight: 'bold', fontSize: '1.1em', textAlign: 'center', position: 'relative' }}
          >查看全部订单内容</Paper>
        </Box>
      }
      {
        <Dialog
          fullWidth
          open={chooseDialogShow}
          onClose={() => { setChooseDialogShow(false) }}
        >
          <DialogTitle className={checkedSubproductArray.length > 0 ? "multiplyModifyCss" : ""}>{checkedSubproductArray.length > 0 ? `批量修改${checkedSubproductArray.length}个` : ''}</DialogTitle>
          <Container
            sx={{ px: 3, pb: 3 }}
          >
            <TextField
              // onWheel={handleOnWheel}
              fullWidth
              name={clickedDialogKey === 'cargo_sent' ? '发货状态' : clickedDialogKey === 'can_pay_balance' ? '开启补款' : '报关进度'}
              type='select'
              select={true}
              label={props.headers[(props.headers_key.indexOf(clickedDialogKey))]}
              defaultValue={chooseItemClickedValue}
              onChange={handleChooseItemChange}
            >
              {
                chooseDialogItems.map((item) =>
                  <MenuItem key={item} value={item}>{item}</MenuItem>
                )
              }
            </TextField>
          </Container>
        </Dialog>
      }{
        <Dialog
          fullWidth
          open={realColumnsModifyDialogShow}
          onClose={() => { setRealColumnsModifyDialogShow(false) }}
        >
          <DialogTitle className={checkedSubproductArray.length > 0 ? "multiplyModifyCss" : ""}>{checkedSubproductArray.length > 0 ? `批量修改${checkedSubproductArray.length}个` : ''}</DialogTitle>
          <Container
            sx={{ px: 3, pb: 3 }}
          >
            <TextField
              // onWheel={handleOnWheel}
              fullWidth
              onInput={handleRealColumnInput}
              name={props.schema.products?.subSchema[clickedDialogKey]?.label}
              type={clickedDialogKey === 'real_pack' || clickedDialogKey === 'real_carton' || clickedDialogKey === 'real_number' || clickedDialogKey === 'custom_carton' || clickedDialogKey === 'can_pay_balance_number' ? 'number' : 'text'}
              defaultValue={realColumnsClickedValue}
              label={props.schema.TABLE.label == "产品" ? props.headers[(props.headers_key.indexOf(clickedDialogKey))] : props.schema.products?.subSchema[clickedDialogKey]?.label}
            >
            </TextField>
          </Container>
          <DialogActions>
            <Button
              sx={{ m: 1 }}
              onClick={() => setRealColumnsModifyDialogShow(false)}
            >
              {"取消"}
            </Button>

            <Button
              onClick={handleRealColumnModifySubmit}
            >
              {"提交"}
            </Button>
          </DialogActions>
        </Dialog>
      }
      <Backdrop
        sx={{ background: '#00000044', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={exportPercentage > 0}
      >
        <Box sx={{ background: '#fff', display: 'flex', borderRadius: '100%' }}>
          <CircularProgressWithLabel value={exportPercentage} />
        </Box>
      </Backdrop>
    </TableContainer>
  )
}

export default OrderTableArray